import defaultSearchCountry from './forms/HeroSearchForm/defaultSearchCountry';
import routeConfiguration from './routeConfiguration';
import { createResourceLocatorString } from './util/routes';

// ================ App ================ //
export const appleAppLink = 'https://apps.apple.com/de/app/vansite/id1573760276';
export const androidAppLink = 'https://play.google.com/store/apps/details?id=eu.vansite.mobile';

// ================ Shop ================ //
export const shopLink = 'https://shop.vansite.eu';

// ================ Reviews ================ //
export const trustpilotLink = 'https://ch.trustpilot.com/review/vansite.eu';
export const googleReviewLink =
  'https://www.google.com/search?sa=X&sca_esv=4e60fa2acf45c742&rlz=1C1VDKB_deDE1010DE1011&tbm=lcl&q=VanSite+Rezensionen&rflfq=1&num=20&stick=H4sIAAAAAAAAAONgkxI2sjA1tTS1MDUyNLMwsrA0NzQy28DI-IpROCwxLzizJFUhKLUqNa84Mz8vNW8RKzZRABMdKm5GAAAA&rldimm=2855958521682897126&hl=de-DE&ved=2ahUKEwjluceR6vaGAxVrnf0HHXCPCc0Q9fQKegQIOBAF&biw=1664&bih=975&dpr=1.5#lkt=LocalPoiReviews';

// ================ Stripe ================ //
export const stripeLink = 'https://stripe.com/';
export const stripeAccountConnectLink = 'https://stripe.com/connect-account/legal';

// ================ Social Media ================ //
export const siteTwitterHandle = '@VanSite_eu'; // Twitter handle is needed in meta tags (twitter:site). Start it with '@' character
export const siteInstagramPage = 'https://www.instagram.com/vansite.eu/';
export const siteFacebookPage = 'https://www.facebook.com/VanSite.eu';
export const siteTiktokPage = 'https://www.tiktok.com/@vansite';
export const siteLinkedInPage = 'https://linkedin.com/company/vansite';
export const siteYouTubePage = 'https://www.youtube.com/@vansiteeu';

// ================ Link Functions ================ //
const HELP_CENTER_BASE = 'https://help.vansite.eu';

// Slugs of the help center category pages, per locale.
const HELP_CENTER_SLUGS = {
  de: { customer: 'reisende', host: 'gastgeber' },
  en: { customer: 'travelers', host: 'hosts' },
  es: { customer: 'viajeros', host: 'anfitriones' },
  fr: { customer: 'voyageurs', host: 'hotes' },
  it: { customer: 'viaggiatori', host: 'host' },
  no: { customer: 'reisende', host: 'verter' },
  sv: { customer: 'resenarer', host: 'vardar' },
};

const helpCenterLocale = (locale) => (HELP_CENTER_SLUGS[locale] ? locale : 'en');

export const getHelpCenterLink = (locale) => `${HELP_CENTER_BASE}/${helpCenterLocale(locale)}`;

export const getMapLink = (locale) => {
  const { address, bounds } = defaultSearchCountry(locale);

  const ne = bounds.ne; // bounds is a LatLngBounds object with NE and SW corners
  const sw = bounds.sw;
  const boundsString = `${ne.lat},${ne.lng},${sw.lat},${sw.lng}`;

  const searchParams = {
    address,
    bounds: boundsString,
    mapSearch: true,
  };

  // Create the internal route for SearchPage with the given params
  return createResourceLocatorString('SearchPage', routeConfiguration(), {}, searchParams, locale);
};

export const getSignUpLink = (locale) => {
  return createResourceLocatorString('SignupPage', routeConfiguration(), {}, {}, locale);
};

export const getFAQLinks = (locale, type) => {
  const lang = helpCenterLocale(locale);

  return `${HELP_CENTER_BASE}/${lang}/${HELP_CENTER_SLUGS[lang][type === 'customer' ? 'customer' : 'host']}`;
};
